module.exports = __webpack_public_path__ + "img/dox-registration-success-loop.34c120a3.gif";